<div class="dialog-container">
  <div class="dialog-content">
    <h1>{{ 'fertilizationBalance.sendCancellationMail' | translate }}</h1>
    <p>{{ 'fertilizationBalance.sendCancellationMailDescription' | translate }}</p>
    <ul>
      @for (setting of data.fertilizationBalanceSettings; track setting) {
        <li>
          {{ setting.name }}
        </li>
      }
    </ul>
  </div>
  <div class="dialog-actions">
    <button mat-flat-button (click)="cancel()">{{ 'close' | translate }}</button>
    <button mat-flat-button color="primary" (click)="confirm()">
      {{ 'confirm' | translate }}
    </button>
  </div>
</div>
